import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "updateArticle" }
const _hoisted_2 = { class: "mdBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mark_extension = _resolveComponent("mark-extension")!
  const _component_md_editor = _resolveComponent("md-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_md_editor, {
        toolbarsExclude: "[ 'katex', 'github']",
        toolbars: _ctx.toolbars,
        modelValue: _ctx.markValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.markValue) = $event)),
        onOnUploadImg: _ctx.onUploadImg,
        onOnSave: _ctx.codeSave,
        onOnHtmlChanged: _ctx.saveHtml,
        onOnGetCatalog: _ctx.onGetCatalog,
        preview: true,
        htmlPreview: true,
        ref: "codeEditor",
        "code-theme": "kimbie",
        footers: _ctx.footers,
        class: "isUpdateMd"
      }, {
        defToolbars: _withCtx(() => [
          _createVNode(_component_mark_extension, { onOnChange: _ctx.onChange }, null, 8, ["onOnChange"])
        ]),
        _: 1
      }, 8, ["toolbars", "modelValue", "onOnUploadImg", "onOnSave", "onOnHtmlChanged", "onOnGetCatalog", "footers"])
    ])
  ]))
}